export const formatSchedulerSettingDisplay = (
	value: number | null | undefined,
	suffix = ''
): string => {
	if (value === null || value === undefined) {
		return '—';
	}
	return `${value}${suffix}`;
};

export const isSchedulerSettingSet = (value: number | null | undefined): value is number =>
	value !== null && value !== undefined;
